<template>
  <div>
    <el-tabs v-model="active_subtab" @tab-click="tabClick">
      <el-tab-pane label="Global View" name="global_view">
        <el-row>
          <el-date-picker
            v-model="reports_date_range"
            class="float-right"
            type="daterange"
            unlink-panels
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            :picker-options="dateRangeOptions"
            format="d MMMM yyyy"
            value-format="yyyy-MM-dd"
            @change="filter()"
          ></el-date-picker>
          <el-select v-model="collective_value" placeholder="Choose data">
            <el-option
              v-for="item in collective_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row v-if="collective_value === 'Artist'">
          <el-col id="vid" :span="24">
            <h1>Number of Artists/Labels</h1>
          </el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_artist"
              :options="LineChartSett"
            />
          </el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_artist_daily"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="collective_value === 'Tracks'">
          <el-col id="vid" :span="24"><h1>Number of Tracks</h1></el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_track"
              :options="LineChartSett"
            />
          </el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_track_daily"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="collective_value === 'Videos'">
          <el-col id="vid" :span="24"><h1>Number of Videos</h1></el-col>
          <el-col id="vid" :span="20" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_videos"
              :options="LineChartSett"
            />
          </el-col>
          <el-col id="vid" :span="20" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_videos_daily"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="collective_value === 'Subscribers'">
          <el-col id="vid" :span="24"
            ><h1>Number of YouTube channel subscribers</h1></el-col
          >
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_subscribers"
              :options="LineChartSett"
            />
          </el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_subscribers_daily"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="collective_value === 'Views'">
          <el-col id="vid" :span="24"><h1>Number of Views</h1></el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_views"
              :options="LineChartSett"
            />
          </el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_views_daily"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="collective_value === 'Channels'">
          <el-col id="vid" :span="24"><h1>Number of Channels</h1></el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_channels"
              :options="LineChartSett"
            />
          </el-col>
          <el-col id="vid" :span="24" :lg="12">
            <GChart
              type="LineChart"
              :data="snapshot_channels_daily"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Territorial Reporting" name="territorial">
        <Territorial />
      </el-tab-pane>
      <!--<el-tab-pane label="License Usage" name="license">
        <Category />
      </el-tab-pane>-->
      <el-tab-pane label="Campaigns Reports" name="vidcents_data">
        <Vidcents />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import Territorial from './Territorial'
import Category from './Category'
import Vidcents from './Vidcents'

export default {
  components: {
    GChart,
    Territorial,
    Category,
    Vidcents
  },

  data() {
    return {
      active_subtab: 'global_view',
      reports_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ],
      collective_value: 'Videos',
      collective_options: [
        {
          value: 'Channels',
          label: 'Channels'
        },
        {
          value: 'Subscribers',
          label: 'Subscribers'
        },
        {
          value: 'Videos',
          label: 'Videos'
        },
        {
          value: 'Views',
          label: 'Views'
        },
        {
          value: 'Artist',
          label: 'Artist'
        },
        {
          value: 'Tracks',
          label: 'Tracks'
        }
      ]
    }
  },

  computed: {
    ...mapState('reports', [
      'loading',
      'snapshot',
      'LineChartSett',
      'date_range'
    ]),

    ...mapState('reportsCategory', ['categories', 'category_data']),
    ...mapState('reportsTerritorial', ['territorial']),
    ...mapState('reportsVC', ['vc_views']),

    ...mapGetters('auth', ['admin_role']),
    ...mapGetters('reports', [
      'snapshot_artist',
      'snapshot_artist_daily',
      'snapshot_track',
      'snapshot_track_daily',
      'snapshot_subscribers',
      'snapshot_subscribers_daily',
      'snapshot_views',
      'snapshot_views_daily',
      'snapshot_videos',
      'snapshot_videos_daily',
      'snapshot_channels',
      'snapshot_channels_daily'
    ]),

    color() {
      return '#' + Math.floor(Math.random() * 16777215).toString(16)
    }
  },

  methods: {
    ...mapActions('reports', ['readSnapshot']),
    ...mapActions('reportsVC', ['readCollective']),
    ...mapActions('reportsTerritorial', ['readTerritorial']),
    ...mapActions('reportsCategory', ['readCategoriesChartData', 'readCategoriesData']),
    ...mapActions('vcLabel', ['readLabels']),

    ...mapMutations('reports', ['setDateRange']),

    tabClick(tab) {
      if (tab.name === 'vidcents_data' && this.vc_views.length == 0) {
        this.readCollective('vc_views'); 
        this.readLabels();
      }
      if (tab.name === 'territorial' && this.territorial.length == 0) {
        this.readTerritorial();
      }
      if (tab.name === 'license' && this.categories.length == 0 && this.category_data.length == 0) {
        this.readCategoriesChartData();
        this.readCategoriesData();
      }
    },

    openYouTube(id) {
      window.open(`https://www.youtube.com/watch?v=${id}`)
    },

    filter() {
      this.setDateRange({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1]
      }),
      this.readSnapshot({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1]
      })
    }
  },

  created() {
    setTimeout(() => {
      this.filter()
    }, 1000)
  }
}
</script>

<style scoped>
h1 {
  text-align: center;
  font-weight: 200;
  font-size: 1.7rem;
}

.link {
  text-decoration: underline;
}

.color {
  background-color: aquamarine;
  color: #4e4e4e;
  text-align: center;
}

.el-row {
  margin-top: 1rem;
}
</style>
